export default __webpack_public_path__ + "static/media/icon-font.8739db49.eot";